import { useEffect } from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main className="pt-16">
        <section className="relative bg-secondary-500 py-20">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6 text-center">
            <nav className="flex items-center justify-center gap-2 text-sm text-background-50/60 mb-6">
              <Link to="/" className="hover:text-accent-400 transition-colors whitespace-nowrap">
                首页
              </Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-background-50 font-medium">关于我们</span>
            </nav>
            <h1
              className="text-3xl md:text-5xl font-bold text-background-50 mb-4"
              style={{ fontFamily: "var(--font-heading)" }}
            >
              关于韩漫世界
            </h1>
            <p className="text-background-50/70 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
              致力于为全球中文读者提供最优质的韩国漫画阅读体验
            </p>
          </div>
        </section>

        <section className="max-w-[1400px] mx-auto px-4 md:px-6 py-16">
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
              <div className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-primary-100 flex items-center justify-center">
                  <i className="ri-book-open-line text-2xl text-primary-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">海量内容</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  收录超过5000部韩国漫画，涵盖恋爱、奇幻、热血、悬疑等全部分类，每日更新，绝不断更。
                </p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-line text-2xl text-accent-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">无删减原版</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  坚持提供无删减韩漫大全，保留原作全部精彩内容，给您原汁原味的韩国漫画阅读体验。
                </p>
              </div>
              <div className="text-center p-8 rounded-2xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 rounded-2xl bg-green-100 flex items-center justify-center">
                  <i className="ri-smartphone-line text-2xl text-green-600"></i>
                </div>
                <h3 className="text-lg font-semibold text-foreground-900 mb-2">下拉式阅读</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  免费漫画下拉式观看，专为移动端和桌面端优化，无需翻页，一气呵成的沉浸式阅读体验。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2
                className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                品牌故事
              </h2>
              <div className="prose prose-sm max-w-none text-foreground-700 leading-relaxed space-y-4">
                <p>
                  韩漫世界创立于2020年，由一群热爱韩国漫画的资深读者和工程师共同打造。我们深知中文读者对于优质韩漫内容的渴望，因此致力于建立一个内容全面、阅读体验极致的韩漫在线阅读平台。
                </p>
                <p>
                  在韩漫世界，您能找到最全的<strong>无删减韩漫大全</strong>——从热门连载到经典完结，从恋爱甜宠到热血战斗，每一部作品都经过精心筛选和汉化，确保内容质量和阅读流畅度。
                </p>
                <p>
                  我们深知，<strong>好看的韩国漫画</strong>不仅仅是娱乐，更是一种文化体验。韩漫以其独特的画风、紧凑的剧情和深刻的人物塑造赢得了全球读者的喜爱。韩漫世界作为这一文化传播的桥梁，始终坚持以用户为中心，不断优化阅读体验。
                </p>
                <p>
                  我们的<strong>免费漫画下拉式观看</strong>模式彻底改变了传统的翻页阅读方式。无论您是在通勤路上还是睡前放松，只需轻轻下滑，漫画内容便会自动加载，让您完全沉浸在故事之中，无需中断。
                </p>
                <p>
                  今天，韩漫世界已经成长为中文互联网上最受欢迎的韩漫阅读平台之一，日均活跃用户超过百万，作品库持续扩充。我们不断倾听用户反馈，迭代产品功能，只为给您带来更好的阅读体验。
                </p>
              </div>
            </div>

            <div className="mb-16">
              <h2
                className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                用户口碑
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="p-6 rounded-2xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "韩漫世界的下拉式阅读体验真的太棒了！之前在其他平台看漫画总要翻页，在这里一路下滑就能看，完全不会被打断阅读节奏。"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-secondary-200 flex items-center justify-center text-sm font-semibold text-secondary-700">
                      L
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">林小雨</p>
                      <p className="text-xs text-foreground-500">3年忠实用户</p>
                    </div>
                  </div>
                </div>

                <div className="p-6 rounded-2xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "这里是我见过韩漫最全的网站，很多小众但好看的韩国漫画都能找到。而且无删减真的太重要了，剧情完整度完全不一样！"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-primary-200 flex items-center justify-center text-sm font-semibold text-primary-700">
                      W
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">王大明</p>
                      <p className="text-xs text-foreground-500">漫画深度爱好者</p>
                    </div>
                  </div>
                </div>

                <div className="p-6 rounded-2xl bg-background-100">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                    "更新速度真的快！每次韩网更新后，这里很快就能看到中文版本了。而且界面干净整洁，没有乱七八糟的广告弹窗。"
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-9 h-9 rounded-full bg-accent-200 flex items-center justify-center text-sm font-semibold text-accent-700">
                      Z
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">张美琪</p>
                      <p className="text-xs text-foreground-500">每日追更达人</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <h2
                className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                联系我们
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-3xl mx-auto">
                <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-primary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-mail-line text-xl text-primary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h4>
                    <p className="text-sm text-foreground-600">contact@hanmanshijie.com</p>
                    <p className="text-xs text-foreground-400 mt-1">商务合作 / 内容反馈 / DMCA</p>
                  </div>
                </div>
                <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-customer-service-line text-xl text-accent-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">在线客服</h4>
                    <p className="text-sm text-foreground-600">工作日 9:00 - 18:00 (KST)</p>
                    <p className="text-xs text-foreground-400 mt-1">周末及节假日休息</p>
                  </div>
                </div>
                <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-green-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-map-pin-line text-xl text-green-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h4>
                    <p className="text-sm text-foreground-600">韩国首尔特别市江南区德黑兰路 123 号</p>
                    <p className="text-xs text-foreground-400 mt-1">Gangnam-gu, Seoul, South Korea</p>
                  </div>
                </div>
                <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 flex items-start gap-4">
                  <div className="w-11 h-11 rounded-xl bg-secondary-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-xl text-secondary-600"></i>
                  </div>
                  <div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1">社交媒体</h4>
                    <div className="flex gap-3 mt-1">
                      <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" rel="nofollow" aria-label="微博">
                        <i className="ri-weibo-line"></i>
                      </a>
                      <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" rel="nofollow" aria-label="微信">
                        <i className="ri-wechat-line"></i>
                      </a>
                      <a href="#" className="w-8 h-8 rounded-full bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-500 hover:bg-primary-50 transition-colors" rel="nofollow" aria-label="B站">
                        <i className="ri-bilibili-line"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16 bg-background-100">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto">
              <h2
                className="text-2xl md:text-3xl font-bold text-foreground-950 mb-8 text-center"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  { q: "韩漫世界的漫画都是免费的吗？", a: "是的！我们的核心理念是提供免费漫画下拉式观看体验。大部分漫画章节都可以免费阅读，让您尽情享受韩国漫画的精彩内容。" },
                  { q: "韩漫世界的更新频率是怎样的？", a: "我们与韩国各大漫画平台保持同步更新，热门连载漫画在韩网更新后24小时内即可在韩漫世界阅读中文版本。" },
                  { q: "为什么选择韩漫世界而不是其他平台？", a: "韩漫世界提供无删减韩漫大全，所有漫画均为原版内容无删减。同时，我们的下拉式阅读模式专为舒适阅读设计，让您体验最流畅的漫画阅读。" },
                  { q: "如何在手机上获得最佳阅读体验？", a: "韩漫世界全面适配移动端，只需在手机浏览器中打开网站即可享受优化的下拉式阅读体验，无需下载App。" },
                  { q: "遇到图片加载缓慢怎么办？", a: "我们使用了全球CDN加速，通常情况下加载速度很快。如果遇到加载缓慢，建议检查网络连接或尝试切换网络环境。" },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70">
                    <summary className="flex items-center justify-between px-6 py-4 cursor-pointer list-none">
                      <span className="text-sm font-medium text-foreground-800">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-6 pb-4">
                      <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            name: "关于韩漫世界",
            description: "韩漫世界 - 无删减韩漫大全与好看的韩国漫画在线阅读平台，提供免费漫画下拉式观看",
            about: {
              "@type": "Organization",
              name: "韩漫世界",
              url: "https://hanmanshijie.com/",
              description: "韩漫世界致力于为全球中文读者提供最优质的韩国漫画阅读体验",
              email: "contact@hanmanshijie.com",
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: [
              { "@type": "Question", name: "韩漫世界的漫画都是免费的吗？", acceptedAnswer: { "@type": "Answer", text: "是的！我们的核心理念是提供免费漫画下拉式观看体验。大部分漫画章节都可以免费阅读，让您尽情享受韩国漫画的精彩内容。" } },
              { "@type": "Question", name: "韩漫世界的更新频率是怎样的？", acceptedAnswer: { "@type": "Answer", text: "我们与韩国各大漫画平台保持同步更新，热门连载漫画在韩网更新后24小时内即可在韩漫世界阅读中文版本。" } },
              { "@type": "Question", name: "为什么选择韩漫世界而不是其他平台？", acceptedAnswer: { "@type": "Answer", text: "韩漫世界提供无删减韩漫大全，所有漫画均为原版内容无删减。同时，我们的下拉式阅读模式专为舒适阅读设计，让您体验最流畅的漫画阅读。" } },
              { "@type": "Question", name: "如何在手机上获得最佳阅读体验？", acceptedAnswer: { "@type": "Answer", text: "韩漫世界全面适配移动端，只需在手机浏览器中打开网站即可享受优化的下拉式阅读体验，无需下载App。" } },
              { "@type": "Question", name: "遇到图片加载缓慢怎么办？", acceptedAnswer: { "@type": "Answer", text: "我们使用了全球CDN加速，通常情况下加载速度很快。如果遇到加载缓慢，建议检查网络连接或尝试切换网络环境。" } },
            ],
          }),
        }}
      />
    </>
  );
}